import React, { useState } from "react";
import { api } from "@/lib/api";
import { Mail, Phone, MapPin } from "lucide-react";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "General Inquiry", message: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/public/contact", form);
      setSent(true);
      setForm({ name: "", email: "", phone: "", subject: "General Inquiry", message: "" });
    } catch {}
  };

  return (
    <div className="bg-white" data-testid="contact-page">
      <section className="bg-navy text-white py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="overline text-gold">Contact</div>
          <h1 className="font-display text-4xl lg:text-6xl mt-4">Let's talk.</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-1 space-y-8">
          <div className="p-8 bg-slate-50 border border-slate-200">
            <Phone className="w-5 h-5 text-gold mb-3" />
            <div className="overline text-gold">Phone</div>
            <a href="tel:+14033366663" className="font-display text-xl text-navy mt-1 block hover:text-gold transition" data-testid="contact-page-phone">+1 403-336-6663</a>
            <div className="text-sm text-slate-500 mt-1">Mon–Fri · 9a–7p MT</div>
          </div>
          <div className="p-8 bg-slate-50 border border-slate-200">
            <Mail className="w-5 h-5 text-gold mb-3" />
            <div className="overline text-gold">Email</div>
            <a href="mailto:rohin@forterealty.ca" className="font-display text-xl text-navy mt-1 block hover:text-gold transition break-all" data-testid="contact-page-email">rohin@forterealty.ca</a>
          </div>
          <div className="p-8 bg-slate-50 border border-slate-200">
            <MapPin className="w-5 h-5 text-gold mb-3" />
            <div className="overline text-gold">Office</div>
            <div className="font-display text-xl text-navy mt-1">Calgary, Alberta</div>
            <div className="text-sm text-slate-500 mt-1">Serving all of Alberta, Canada</div>
          </div>
        </div>

        <div className="lg:col-span-2 grid gap-8">
          <form onSubmit={submit} className="bg-white border border-slate-200 p-8 lg:p-10 space-y-4" data-testid="contact-page-form">
            <div className="overline text-gold">Send a message</div>
            <h2 className="font-display text-3xl text-navy">We read every inquiry.</h2>
            {sent ? (
              <div className="p-4 bg-slate-50 border border-gold text-navy" data-testid="contact-page-success">Thank you — a senior advisor will respond within one business day.</div>
            ) : (
              <>
                <div className="grid md:grid-cols-2 gap-3">
                  <input required placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="cp-name" />
                  <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="cp-email" />
                </div>
                <input placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="cp-phone" />
                <select value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold bg-white" data-testid="cp-subject">
                  <option>General Inquiry</option><option>Residential</option><option>Commercial</option>
                  <option>Dental Practice</option><option>Medical Clinic</option><option>Press/Media</option>
                </select>
                <textarea required rows="5" placeholder="Message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:border-gold" data-testid="cp-message" />
                <button className="btn-navy w-full" data-testid="cp-submit">Send Message</button>
              </>
            )}
          </form>
          <div className="aspect-[16/7] border border-slate-200">
            <iframe title="map" width="100%" height="100%" style={{ border: 0 }} loading="lazy"
              src="https://maps.google.com/maps?q=Calgary,%20Alberta&t=m&z=11&output=embed" data-testid="contact-map" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
